module.exports = __webpack_public_path__ + "static/img/result_main_banner.41f0f6c4.png";